import api from './api';

export type ChannelMix =
  | 'email'
  | 'linkedin_email'
  | 'linkedin_email_call'
  | 'linkedin_first'
  | 'email_first';

export type AudienceProfile = 'young_urban' | 'traditional';

export interface DesignSequenceInput {
  channelMix: ChannelMix;
  listSize?: number;
  context?: string;
  audienceProfile?: AudienceProfile;
  goal?: string;
  icpId?: string;
  personaId?: string;
  offerId?: string;
  product?: string;
}

export interface SequenceStep {
  step: number;
  day: number;
  channel: string;
  action: string;
  purpose: string;
  conditionalLogic?: string;
  timingNote?: string;
}

export interface SequenceArchitecture {
  campaignName: string;
  icp: string;
  offer: string;
  recommendedListSize: string;
  expectedReplyRate: string;
  steps: SequenceStep[];
  branches: string[];
  rationale: string;
  avoid: string[];
}

export interface DesignResult {
  architecture: SequenceArchitecture | null;
  benchmarkReplyRate?: number;
  raw?: string;
  provider: string;
  model: string;
}

class CampaignArchitectService {
  async design(input: DesignSequenceInput): Promise<DesignResult> {
    const response = await api.post('/campaign-architect/design', input);
    return response.data;
  }
}

const campaignArchitectService = new CampaignArchitectService();
export default campaignArchitectService;
